const serializeValue = (value) => {
    if (value instanceof Error) {
        return {name: value.name, message: value.message, stack: value.stack}
    }

    if (value && typeof value === 'object') {
        return Object.entries(value).reduce((acc, [key, entry]) => {
            acc[key] = serializeValue(entry)
            return acc
        }, {})
    }

    return value
}

/**
 * logging for add-to-cart failures.
 */
export const logBasketErrorToSsr = (step, context = {}) => {
    try {
        fetch('/atcxl/log-error', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                step,
                context: serializeValue(context)
            }),
            keepalive: true
        }).catch(() => {})
    } catch (e) {
        // Ignore
    }
}
